export const isActivityCompletedCheck = ({
  activityToCheck,
  completedLessonActivities,
}) =>
  activityToCheck.is_completed ||
  completedLessonActivities.some(
    (completedLessonActivity) =>
      completedLessonActivity.id === activityToCheck.id &&
      completedLessonActivity.completed_at
  );

export const isLessonCompletedCheck = ({ completedLessons, lessonToCheck }) =>
  lessonToCheck.is_completed ||
  completedLessons.some(
    (completedLesson) =>
      completedLesson.id === lessonToCheck.id && completedLesson.completed_at
  );

export const updateCompletedStatusesInLessons = async ({
  activityId,
  completedLessonActivities,
  completedLessons,
  lessons,
}) =>
  lessons.map((lesson) => ({
    ...lesson,
    activities: lesson.activities.map((lessonActivity) => ({
      ...lessonActivity,
      is_completed:
        lessonActivity?.id === activityId ||
        isActivityCompletedCheck({
          activityToCheck: lessonActivity,
          completedLessonActivities,
        }),
    })),
    is_completed: isLessonCompletedCheck({
      completedLessons,
      lessonToCheck: lesson,
    }),
  }));

export const getObjectSizeInBytes = (object) => {
  const objectString = JSON.stringify(object);
  return new TextEncoder().encode(objectString).length;
};
